import { useContext } from "react";
import UserContext from "../../context/user";
import CartContext from "../../context/cart";

const CartDeliveryFallback = () => {
  const { userProfile } = useContext(UserContext);
  const { labels } = useContext(CartContext);

  return (
    <div className="wrapper wrapper-small">
      <div
        className="carrello-content__text"
        dangerouslySetInnerHTML={{
          __html: (
            labels?.WELFARE_CART_PICKUP_FALLBACK_DESCRIPTION ||
            "<p><strong>Ciao [USER]</strong><br/>Ti chiediamo gentilmente di contattare il Welfare EssilorLuxottica a questa mail <a href='mailto:welfare@essilorluxottica.com'>welfare@essilorluxottica.com</a> per concordare una modalità di ritiro o consegna del tuo carrello</p>"
          ).replace(
            "[USER]",
            `<span translate="no">${userProfile?.firstName} ${userProfile?.lastName}</span>`
          ),
        }}
      />
    </div>
  );
};

export default CartDeliveryFallback;
